import React, { useRef } from 'react';
import { COLOR_MAP, overlayInnerStyle } from '../../utils';
import { IMemberInfo, MEMBER_TYPE } from '../../interface';
import { Iconfont, Tooltip } from '@umu/umu-design';
import { UserAvatar } from '../../../user';
import { getAvatarWord } from '../../../@loadAvatar/loadAvatar';
interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    info: IMemberInfo;
    onDelete: (item: IMemberInfo) => void;
}

const MemberItemInfo = (props: IProps) => {
    const { info, onDelete, ...rest } = props;
    const refDiv = useRef<HTMLDivElement>(null);
    const isDepartment = info.type === MEMBER_TYPE.DEPARTMENT;
    const label = !!info ? info.name || info.login_name || info.email || info.phone || '' : '';
    const renderAvatar = () => {
        if (isDepartment) {
            return <div className="department-search-organize-icon-circle" />;
        }
        return info.avatar ? (
            <UserAvatar className="avatar-component" src={info.avatar || ''} width={20} />
        ) : (
            <div
                className="department-search-avatar-label"
                style={{ backgroundColor: COLOR_MAP[Number(info.id) % COLOR_MAP.length || 0] }}
            >
                {getAvatarWord(label)}
            </div>
        );
    };
    const renderLabel = () => {
        const pathList = (info.path || []).map((pathItem) => pathItem.name);
        return `${pathList.join(' / ')}${pathList.length > 0 ? ' / ' : ''}${label}`;
    };
    const renderOverlay = () => {
        return (
            <div className="member-item-overlay" {...rest}>
                <div className="member-item-overlay-item">
                    {renderAvatar()}
                    <div className="select-item-label">{renderLabel()}</div>
                </div>
                <Iconfont type="Trash" className="member-item-icon" onClick={() => onDelete(info)} />
            </div>
        );
    };
    return (
        <Tooltip
            title={renderOverlay()}
            hideArrow
            placement="topLeft"
            color="#ffffff"
            trigger={['click']}
            align={{
                offset: [0, 5],
            }}
            zIndex={2100/*面板层级为2100*/}
            destroyTooltipOnHide
            overlayClassName="member-item-overlay-container"
            overlayInnerStyle={overlayInnerStyle}
        >
            <div className="select-item" ref={refDiv}>
                {renderAvatar()}
                <div className="select-item-label">{label}</div>
            </div>
        </Tooltip>
    );
};
export default MemberItemInfo;
